import React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import CancelIcon from "@mui/icons-material/Cancel";
import Button from "../SelectValue/Button";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  maxWidth: 400,
  bgcolor: "white",
  boxShadow: 24,
  outline: "none",
  borderRadius: "8px",
  p: 3,
};

export default function FailedModal({
  open,
  handleClose,
  handleRetry,
  errorMessage,
}) {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Box sx={modalStyle}>
          <div className="flex justify-end mb-2">
            <CancelIcon
              onClick={handleClose}
              className="text-[#808285] cursor-pointer text-[28px]"
            />
          </div>

          <div className="flex flex-col items-center justify-center text-center mt-4">
            <div className="w-[80px] h-[80px] rounded-full bg-[#FFEAE5] flex items-center justify-center mb-6">
              <CancelIcon sx={{ fontSize: 40, color: "#FF3B30" }} />
            </div>

            <h2 className="text-[#1E222B] text-[24px] font-bold mb-2">
              Payment Failed
            </h2>
            <p className="text-[#808285] text-[14px] mb-8 leading-relaxed px-4">
              {errorMessage ||
                "Something went wrong with your transaction. Please try again."}
            </p>

            <div className="w-full flex flex-col gap-3">
              <Button
                name="Try Again"
                onClick={handleRetry}
                className="w-full"
              />
              <button
                onClick={handleClose}
                className="w-full py-3 rounded-lg text-[#1E222B] font-medium text-[14px] border border-[#E6E6E7] hover:bg-[#FAFBFC]"
              >
                Cancel
              </button>
            </div>
          </div>
        </Box>
      </Fade>
    </Modal>
  );
}
